import { ChevronRightIcon } from '@navikt/aksel-icons';
import classes from './Breadcrumbs.module.css';

export const BreadcrumbSeparator = () => (
  <li className={classes.separator} aria-hidden="true">
    <ChevronRightIcon fontSize={16} />
  </li>
);
